import { detectEmbedProvider } from './embedProviders';

/**
 * Liens de la banque proposables comme source d'un média — module pur.
 *
 * Une adresse ne dit pas ce qu'elle sert : `picsum.photos/200/300` rend une
 * image sans porter d'extension, et interroger chaque lien de la banque pour
 * connaître son type MIME n'est pas envisageable. On ne peut donc **pas**
 * décider qu'un lien est une image ; on peut seulement écarter ceux dont
 * l'extension dit le contraire — un `.mp4` n'a rien à faire dans un champ
 * image, ni un `.jpg` dans un champ vidéo. Le reste est proposé, l'aperçu du
 * champ montre immédiatement si l'adresse ne rend rien.
 */

const IMAGE_EXTENSIONS = /\.(png|jpe?g|gif|webp|avif|svg)(\?|#|$)/i;
const VIDEO_EXTENSIONS = /\.(mp4|webm|ogv|ogg|mov|m4v)(\?|#|$)/i;

export function isLinkUsableAs(url, kind = 'image') {
  if (typeof url !== 'string' || !url) return false;
  if (kind === 'video') return !IMAGE_EXTENSIONS.test(url);
  return !VIDEO_EXTENSIONS.test(url) && !detectEmbedProvider(url);
}
